import { MajorResponse } from '@api/gateway/Resourcetag-Default'

export class IndustryAndMajor {
  /**
   * 行业关系id
   */
  relationId: string
  /**
   * 行业名称
   */
  name: string
  /**
   * 行业id
   */
  id: string
  /**
   * 该行业下专业集合
   */
  major: MajorResponse
}
